<template>
    <div id="container" class="md-layout">
        <h1 class="md-layout-item md-size-80 md-small-size-90">
            Impressum
        </h1>

        <md-card class="md-layout-item md-size-80 md-small-size-90">
            <md-card-content>
                Websitebetreiber, V.i.S.d.P. und nach TDG:<br>
                <br>
                Martin Bischoff<br>
                Orthopädieschuhmachermeister<br>
                Orthopädietechniker<br>
                <br>
                Eingetragen seit dem 13.03.1995<br>
                in der Handwerksrolle der<br>
                Handwerkskammer Mittelfranken<br>
                Betriebsnummer: 68341<br>
                USt-IdNr.: 169303938<br>
                <br>
                Postanschrift:<br>
                Schalkhäuser Str. 18<br>
                91522 Ansbach<br>
                <br>
                <a href="mailto:info@paw-blueprint.de">info@paw-blueprint.de</a> <br>
                <br>
                <br>
                Wir verwenden freie Software. Infos dazu gibt es <a href="/#/licences/">hier</a>.
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
export default {
    name: 'All_Imprint'
}
</script>

<style lang="scss" scoped>
#container {
    background-color: #FFFFFF;
    border: 1px solid #CCCCCC;
    padding: 20px;
    margin-top: 10px;
    align-content: center;
    text-align: center;
}

.md-card {
    text-align: center;
    width: 980px;
    max-width: 90%;
    margin: 10px auto 10px;
    display: inline-block;
    vertical-align: top;
}

h1 {
    text-align: center;
    margin: 10px auto 10px;
}
</style>
